import * as React from "react";
import {useTranslation} from "react-i18next";
import window from "../components/lib/WindowExtended";
import styles from "./Footer.module.scss";
import {getShopId} from "./lib/getShopId";

const links = window.c_links;

const Footer: React.FC = () => {
  const {t} = useTranslation();
  const activeCountry = window.c_ActiveCountry;

  return (
    <footer className={styles.wrapper}>
      <div className={styles.footerNote}>
        {activeCountry === "GB" && (
          <p>
            * All item prices exclude import tax and{" "}
            <a href="https://www.connox.co.uk/help/delivery.html">shipping costs</a>.
          </p>
        )}
        {getShopId() === 100005 && (
          <p>
            ** Please note that there is no right of return for deliveries outside of the European Union, excluding
            Switzerland and United Kingdom.
          </p>
        )}
      </div>

      <div className={styles.linksWrapper}>
        <div>
          <a href={links.URL_Privacy} target="_blank" rel="noopener noreferrer">
            {t("Datenschutz")}
          </a>
          {" / "}
          <a href={links.URL_RevocationRights} target="_blank" rel="noopener noreferrer">
            {t("Widerruf")}
          </a>
          {" / "}
          <a href={links.URL_TermsAndConditions} target="_blank" rel="noopener noreferrer">
            {t("AGB")}
          </a>
          {" / "}
          <a href={links.URL_Imprint} target="_blank" rel="noopener noreferrer">
            {t("Impressum")}
          </a>
        </div>
        <strong>
          {t("Kundenberatung")}
          <a href={`tel:${links.ContactPhone.replace(/(\s|\(|\))/g, "")}`}>{links.ContactPhone}</a>
        </strong>
      </div>
    </footer>
  );
};

export default Footer;
